export enum FeatureFlag {
  NEW_NAVBAR = 'NEW_NAVBAR',
}
